import Vue from 'vue'
import App from './App.vue'

import Resitev from './components/resitev/PmisResitev'
import Main from './components/Main'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './styles/main.scss'
import VModal from 'vue-js-modal'
import VueYoutube from 'vue-youtube'

import {library} from '@fortawesome/fontawesome-svg-core'
import {faCoffee, faChild, faCircle, faArchive, faRedo} from '@fortawesome/free-solid-svg-icons'
import {faComment} from '@fortawesome/free-regular-svg-icons'
import {faJs, faVuejs, faJava, faPhp, faPython, faCss3, faHtml5} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'

import VuePopper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import VueImageChooser from 'vue-image-chooser';

import MenuIcon from 'vue-material-design-icons/Menu.vue';

import {VueReCaptcha} from "vue-recaptcha-v3";

Vue.component('menu-icon', MenuIcon);

import 'v-markdown-editor/dist/v-markdown-editor.css';
import Editor from 'v-markdown-editor'

import {faSpinner, faAlignLeft, faStrikethrough,faHeading} from '@fortawesome/free-solid-svg-icons'

library.add(
    faCoffee,
    faChild,
    faCircle,
    faArchive,
    faRedo,
    faComment,
    faStrikethrough,
    faHeading,
    faJs, faVuejs, faJava, faPhp, faPython, faCss3, faHtml5,
    faSpinner, faAlignLeft
)

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.component('popper', VuePopper);

Vue.component('font-awesome-icon', FontAwesomeIcon)

import {faUserSecret} from '@fortawesome/free-solid-svg-icons'

library.add(faUserSecret)

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueImageChooser);

Vue.use(VueRouter);

Vue.use(VueToast);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

Vue.use(VModal);

Vue.use(VueYoutube);

Vue.use(Editor);

Vue.use(VueReCaptcha, { siteKey: "6LeGi4McAAAAAJVRTPjdqMITKuIqoWgqHIO4kISQ" }); // TODO - env

const routes = [
    {path: '/igralnica', component: Main},
    {path: '/resitev', component: Resitev}];

const router = new VueRouter({
    routes,
    mode: 'history',
    hash: false,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            if (from.path !== "/resitev") {
                var element = document.getElementById(to.hash.replace("#", ""));
                var top = element.offsetTop;
                window.scrollTo({top: top, behavior: 'smooth'});
                return;
            } else
                return {selector: to.hash};
        }
        return {x: 0, y: 0};
    },
    methods: {
        beforeEnter() {
            this.$root.$emit('scrollBeforeEnter');
        }
    }
})

new Vue({
    el: '#app',
    router,
    render: h => h(App),
    components: {App, FontAwesomeIcon, faStrikethrough}
}).$mount('#app');

